import styled, { css } from 'styled-components';

/**
 * 리뉴얼 디자인 토큰 & 섹션 공통 프리미티브.
 * 값은 design_handoff_brit_homepage/README.md 의 Design Tokens 표를 그대로 따릅니다.
 */
export const token = {
  primary: '#E62629',
  primaryHover: '#C01F22',
  primaryDeep: '#B31D20',
  ink: '#111111',
  ink2: '#333333',
  muted: '#5A5A5A',
  faint: '#8A8A8A',
  border: '#DDDDDD',
  borderLight: '#E5E5E5',
  inputBorder: '#C8CFD9',
  inputText: '#3F4448',
  surface: '#F5F5F5',
  surfaceAlt: '#FAFAFA',
  surfaceImg: '#F2F2F2',
  heroBg: '#050813',
  heroGlow: 'radial-gradient(90% 70% at 50% 46%, #10182F 0%, #080D1C 45%, #050813 75%)',
  darkText: '#C9C9C9',
  darkMuted: '#8A8A8A',
  heroMuted: '#8FA0C8',
  amber: '#C9A227',
  maxWidth: '1400px',
  ease: 'cubic-bezier(.22,.61,.36,1)',
};

export const SectionShell = styled.section`
  padding: 140px 32px;
  background: ${({ $bg }) => $bg || '#fff'};
  color: ${({ $color }) => $color || token.ink};

  @media screen and (max-width: 768px) {
    padding: 96px 20px;
  }
`;

export const Inner = styled.div`
  max-width: ${token.maxWidth};
  margin: 0 auto;
`;

export const SectionHead = styled.div`
  display: flex;
  align-items: baseline;
  gap: 24px;
  border-top: 2px solid ${({ $dark }) => ($dark ? '#fff' : '#000')};
  padding-top: 24px;
  margin-bottom: ${({ $gap }) => $gap || '96px'};
`;

export const SectionNo = styled.span`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3em;
  color: ${token.primary};
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: clamp(36px, 5vw, 72px);
  font-weight: 800;
  letter-spacing: -0.03em;
`;

export const Lead = styled.p`
  margin: 0 0 ${({ $mb }) => $mb || '96px'};
  font-size: clamp(18px, 2vw, 26px);
  line-height: 1.6;
  color: ${({ $color }) => $color || token.muted};
  max-width: ${({ $max }) => $max || '900px'};
`;

export const Eyebrow = styled.div`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.24em;
  color: ${token.primary};
  margin-bottom: 20px;
`;

/** 블록 소제목 (연혁 / 주요 진행 프로젝트 등) */
export const BlockTitle = styled.h3`
  margin: 0 0 ${({ $mb }) => $mb || '40px'};
  font-size: clamp(26px, 3vw, 40px);
  font-weight: 800;
  letter-spacing: -0.03em;
`;

/** 다크 섹션의 소제목 (조금 작은 스케일) */
export const BlockTitleSm = styled.h3`
  margin: 0 0 ${({ $mb }) => $mb || '40px'};
  font-size: clamp(24px, 2.8vw, 38px);
  font-weight: 800;
  letter-spacing: -0.03em;
`;

export const Block = styled.div`
  margin-bottom: ${({ $mb }) => $mb || '140px'};

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: ${({ $mb }) => ($mb === '0' ? '0' : '88px')};
  }
`;

/**
 * 카드 그리드의 격자선.
 * 컨테이너에 border + overflow:hidden, 각 셀에 같은 색·두께의 outline 을 주고 gap 은 0 입니다.
 * (셀 배경색으로 격자를 그리면 마지막 줄 빈칸에 배경색이 그대로 드러나므로 쓰지 않습니다.)
 */
export const HairlineGrid = styled.div`
  display: grid;
  /* min(…, 100%) 이 없으면 좁은 화면에서 트랙 최소폭이 뷰포트를 밀어내 가로 스크롤이 생깁니다. */
  grid-template-columns: ${({ $cols, $min }) =>
    $cols || `repeat(auto-fit, minmax(min(${$min || '280px'}, 100%), 1fr))`};
  gap: 0;
  background: ${({ $bg }) => $bg || '#fff'};
  border: ${({ $weight }) => $weight || '1px'} solid ${({ $line }) => $line || token.border};
  overflow: hidden;

  > * {
    outline: ${({ $weight }) => $weight || '1px'} solid ${({ $line }) => $line || token.border};
  }
`;

export const Card = styled.div`
  background: ${({ $bg }) => $bg || '#fff'};
  padding: ${({ $pad }) => $pad || '36px 28px'};
`;

/** 원형 번호 뱃지 (SCOPE OF SERVICE) */
export const NumberBadge = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 28px;
`;

export const buttonReset = css`
  background: none;
  border: 0;
  padding: 0;
  font-family: inherit;
  cursor: pointer;
`;
